<template>
  <el-table-column
    prop="creator_user.last_name"
    sortable="custom"
    label="Rögzítette"
    show-overflow-tooltip
    min-width="120"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.creator_user"
        style="display: inline-block;"
      >
        {{ scope.row.creator_user.last_name }} {{ scope.row.creator_user.first_name }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'creator_user.last_name',
  };
</script>
